import React, { useEffect } from 'react'
import Header from 'components/Header'
import Section from './components/Section.jsx'
import Footer from 'components/Footer'

function About() {
  useEffect(() => {
    document.title = 'Macias e Cruz - Quem Somos'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main>
      <Header />
      <Section />
      <Footer />
    </main>
  )
}

export default About
